import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { UnlockCategoryUseCase } from "../../../domain/usecase/category/unlock/UseCase";
import { GetCategoryUnlockCodeUseCase } from "../../../domain/usecase/category/getUnlockCode/UseCase";
import { State } from "../../../domain/model/ResponseState";
import { CategoryUnlockCode } from "../../../domain/model/Category";

export function UnlockCodeViewModel(
  getCategoryUnlockCodeUseCase: GetCategoryUnlockCodeUseCase,
  unlockCategoryUseCase: UnlockCategoryUseCase
) {
  const searchParams = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);
  const [isCategoryUnlocked, setIsCategoryUnlocked] = useState(false);
  const [error, setError] = useState<string>();

  useEffect(() => {
    init();
  }, []);

  function init() {
    const searchParamsValue = searchParams[0];
    const id = searchParamsValue.get("id");

    if (!id) {
      setError("URL is not formatted properly");
      return;
    }

    getCategoryUnlockCode(id);
  }

  async function getCategoryUnlockCode(id: string) {
    setIsLoading(true);
    const response = await getCategoryUnlockCodeUseCase.invoke(id);
    switch (response.responseState) {
      case State.Success:
        if (response.data) unlockCategory(response.data);
        break;
      case State.Fail:
      case State.Error:
        setIsLoading(false);
        setError(response.error?.message);
        break;
    }
  }

  async function unlockCategory(categoryUnlockCode: CategoryUnlockCode) {
    if (!categoryUnlockCode.category || !categoryUnlockCode.code) return;

    setIsLoading(true);
    const response = await unlockCategoryUseCase.invoke(
      {
        categoryId: categoryUnlockCode.category,
        code: categoryUnlockCode.code,
      },
    );
    setIsLoading(false);
    switch (response.responseState) {
      case State.Success:
        setIsCategoryUnlocked(true);
        break;
      case State.Fail:
      case State.Error:
        setError(response.error?.message);
        break;
    }
  }
  return { error, isLoading, isCategoryUnlocked };
}
